import { createGlobalStyle } from 'styled-components';

import { SidebarWidth } from 'ui/components/styled/Sidebar';

export default createGlobalStyle`
* {
  box-sizing: border-box;
  font-family: "Roboto", sans-serif;
  padding: 0;
  margin: 0;
}

*, ::after, ::before {
  box-sizing: border-box;
}

html,
body,
#root {
  position: relative;
  width: 100%;
  height: 100%;
}

body {
  font-size: 1.6rem;
  -ms-touch-action: none;
  touch-action: none;
}

a {
  color: inherit;
  text-decoration: none;
}

input {
  box-shadow: none;
}

a, button {
  cursor: pointer;
}

button:focus,
button:hover,
input:focus {
  outline: none;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, .5);
  box-shadow: 0 0 1px rgba(255, 255, 255, .5);
}

.react-toast-notifications__container {
  overflow: hidden !important;
  word-wrap: break-word;
  white-space: pre-wrap;
  &.with-left-sidebar {
    left: calc(50% + ${SidebarWidth / 2}px);
  }
}

.fullscreen {
  width: 100%;
  height: 100%;
  overflow: auto;
}
`;
